module.exports = __webpack_public_path__ + "img/img17.2288e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img17.jpg
// module id = 282
// module chunks = 0